import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { load } from "@cashfreepayments/cashfree-js";
import "../../BillingComp/BillDetailsModal.scss";
import { useNavigate } from "react-router-dom";

const BillingDetailsGuest = ({ onClose, bookingId, paymentDetails }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [cashfree, setCashfree] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const initializeSDK = async () => {
      try {
        const sdk = await load({ mode: "production" });
        if (isMounted) {
          setCashfree(sdk);
        }
      } catch (error) {
        console.error("Failed to load Cashfree SDK:", error);
        toast.error("Failed to initialize payment gateway.");
      }
    };

    initializeSDK();

    return () => {
      isMounted = false;
    };
  }, []);

  const handlePayment = async () => {
    if (!cashfree || !bookingId) {
      toast.error("Payment gateway or booking ID not available.");
      return;
    }

    setIsLoading(true);
    const accessToken = window.localStorage.getItem("access_token");

    try {
      const paymentResponse = await fetch(
        `https://ballersapi.ballerslife.co/api/v1/memberships/bookings/initiate_guest_payment?booking_id=${bookingId}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const paymentData = await paymentResponse.json();

      if (paymentResponse.ok) {
        setOrderId(paymentData.order_id || `ORD-${Date.now()}`);
        const paymentOptions = {
          paymentSessionId: paymentData.payment_session_id,
          redirectTarget: "_modal",
        };

        cashfree.checkout(paymentOptions).then((result) => {
          setIsLoading(false);
          if (result.error) {
            console.error("Payment error:", result.error);
            setPaymentStatus("failed");
          } else if (result.redirect) {
            console.log("Payment will be redirected.");
          } else if (result.paymentDetails) {
            console.log(
              "Payment completed successfully:",
              result.paymentDetails.paymentMessage
            );
            setPaymentStatus("success");
          }
        });
      } else {
        toast.error(paymentData.detail || "Failed to initiate payment");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Payment initiation error:", error);
      toast.error("An error occurred during payment initiation.");
      setIsLoading(false);
    }
  };

  const SuccessPopup = () => (
    <div className="payment-popup success">
      <button
        className="close-button"
        onClick={() => {
          onClose();
          navigate("/dashboard/joingameDetails/" + bookingId);
        }}
        aria-label="Close popup"
      >
        ×
      </button>
      <div className="popup-icon success-icon">
        <span>✔</span>
      </div>
      <p className="payment_heading">Payment Successful!</p>
      <p className="popup-subtext">
        Your guest booking is confirmed. Time to hit the court!
      </p>
      <p className="popup-subtext">
        Order ID: {orderId}
        <br />
        Amount: ₹{paymentDetails?.total_amount || 0}
      </p>
      <button
        className="modal-button"
        onClick={() => {
          onClose();
          navigate("/dashboard/booking");
        }}
      >
        Go to Bookings
      </button>
    </div>
  );

  const FailurePopup = () => (
    <div className="payment-popup failure">
      <button
        className="close-button"
        onClick={onClose}
        aria-label="Close popup"
      >
        ×
      </button>
      <div className="popup-icon failure-icon">
        <span>✖</span>
      </div>
      <p className="payment_heading">Payment Failed</p>
      <p className="popup-subtext">
        Something went wrong. Please try again or use a different payment
        method.
      </p>
      <p className="popup-subtext">
        Order ID: {orderId}
        <br />
        Amount: ₹{paymentDetails?.total_amount || 0}
      </p>
      <button className="modal-button" onClick={() => handlePayment()}>
        Retry Payment
      </button>
    </div>
  );

  return (
    <div className="bill-modal">
      <div className="bill-modal-content">
        {paymentStatus === "success" ? (
          <SuccessPopup />
        ) : paymentStatus === "failed" ? (
          <FailurePopup />
        ) : (
          <>
            <div className="bill-header">
              <span className="close-btn" onClick={onClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-left-icon lucide-chevron-left"
                >
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </span>
              <p>Bill Details:</p>
            </div>
            <div className="bill-items">
              <div className="bill-item">
                <span>Guest Fee</span>
                <span>₹{paymentDetails?.base_amount || 0}</span>
              </div>
              <div className="bill-item">
                <span>GST ({paymentDetails?.gst_rate_percent || 18}%)</span>
                <span>₹{paymentDetails?.gst_amount || 0}</span>
              </div>
              <div className="bill-total">
                <span>Total</span>
                <span>₹{paymentDetails?.total_amount || 0}</span>
              </div>
            </div>
            <div className="refund-policy">
              <h3>Refund Policy</h3>
              <p>Guest fees will be refunded if the game is cancelled</p>
            </div>
            <button
              className="pay-now-btn"
              onClick={handlePayment}
              disabled={isLoading || !paymentDetails}
            >
              {isLoading ? "Processing..." : "Pay Now!"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default BillingDetailsGuest;
